import styled from 'styled-components';

import { Dialog } from '@poliedro/tamentai';

export const StyledDialogRoot = styled(Dialog.Root)`
  max-width: 520px;
`;
